import { render, staticRenderFns } from "./ObjectAudio.vue?vue&type=template&id=aabe4de0&"
import script from "./ObjectAudio.vue?vue&type=script&lang=js&"
export * from "./ObjectAudio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports